import { render, staticRenderFns } from "./ProjectProgress.vue?vue&type=template&id=6ccfe520&scoped=true&"
import script from "./ProjectProgress.vue?vue&type=script&lang=js&"
export * from "./ProjectProgress.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProgress.vue?vue&type=style&index=0&id=6ccfe520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfe520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VSimpleTable,VTextField})
